<div class="thumbnail-enlarge-dialog-container">
  <img [src]="source" #canvas />
</div>
